import Policy from "@/entities/Policy";
import policiesData from "@/data/policies.json";

const policies = policiesData as unknown as Policy[];

export default class LegalService {
  public async getPolicies(): Promise<Policy[]> {
    return policies;
  }

  public async getPolicyByLinkName(link_name: string): Promise<Policy> {
    const policy = policies.find((p) => p.link_name === link_name);

    if (!policy) {
      throw new Error(
        `Error al obtener la política con link_name ${link_name}.`
      );
    }

    return policy;
  }
}
